import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Returns the list of visited urls since this component has been mounted.
 */
export const useVisitedUrls = () => {
  const location = useLocation();
  const url = location.pathname + location.search;

  const [visitedUrls, setVisitedUrls] = useState<string[]>([]);

  useEffect(() => {
    setVisitedUrls(urls => (urls[urls.length - 1] === url ? urls : [...urls, url]));
  }, [url]);

  return visitedUrls;
};
